import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import surveysRoutes from 'modules/trainingLibrary/Surveys/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const SurveyDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsSurveyDetails" */ 'modules/activityDetails/SurveyDetails/pages/SurveyDetails'
    )
)

const SurveyDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:surveyId`} component={SurveyDetails} />
      <Redirect path='*' to={surveysRoutes.root} />
    </Switch>
  </Suspense>
)

export default SurveyDetailsRouting
